import React from "react";
import { Route, Routes } from "react-router-dom";
import MainVersionPage from "./MainVersionPage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditVersionPage from "./AddEditVersionPage";
import ViewVersionPage from "./ViewVersionPage";
import VersionPageWrapper from "./VersionPageWrapper";
import PageNotFound from "../PageNotFound";

const VersionRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute
            element={<VersionPageWrapper Component={MainVersionPage} />}
          />
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute
            element={<VersionPageWrapper Component={AddEditVersionPage} />}
          />
        }
      />

      <Route
        path=":_id/edit"
        element={
          <ProtectedRoute
            element={<VersionPageWrapper Component={AddEditVersionPage} />}
          />
        }
      />
      <Route
        path=":_id"
        element={
          <ProtectedRoute
            element={<VersionPageWrapper Component={ViewVersionPage} />}
          />
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default VersionRouter;
